export enum ReportTypes {
    PM = 'PM',
    DL = 'DL',
    BROADCASTING_VAN = 'BROADCASTING_VAN',
    DIRECTOR = 'DIRECTOR',
    DFB_CONTRIBUTION = 'DFB_CONTRIBUTION',
    CONTRIBUTION = 'CONTRIBUTION',
    SIGNAL_EVALUATION = 'SIGNAL_EVALUATION'
}